import React, { useState } from 'react';
import { Card, Table, Pagination, Button } from 'react-bootstrap';
import { FaDownload, FaSort, FaSortDown, FaSortUp } from 'react-icons/fa';
import {
  getTableHeaderClass,
  getModernDataTableClass,
  getModernCardHeaderClass,
  getModernCardBodyClass,
  getModernCardFooterClass,
  getModernTableClass,
} from 'utils/tableTheme';
const Results = ({ data, currentTheme }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(40);
  const [orderBy, setOrderBy] = useState(null);
  const [order, setOrder] = useState('asc');

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(Number(event.target.value));
    setPage(0);
  };

  const totalPages = Math.max(1, Math.ceil(data.length / rowsPerPage));

  const getPaginationRange = () => {
    const start = Math.max(page - 2, 0);
    const end = Math.min(page + 2, totalPages - 1);
    const range = [];
    for (let i = start; i <= end; i += 1) {
      range.push(i);
    }
    return range;
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
    setPage(0);
  };

  const renderSortIcon = (column) => {
    if (column !== orderBy) {
      return <FaSort style={{ marginLeft: 5, opacity: 0.5 }} />;
    }
    return order === 'asc'
      ? <FaSortUp style={{ marginLeft: 5, opacity: 1 }} />
      : <FaSortDown style={{ marginLeft: 5, opacity: 1 }} />;
  };

  const getSortedData = (items) => {
    if (!orderBy) return items;

    const stabilized = items.map((el, index) => [el, index]);

    stabilized.sort((a, b) => {
      const itemA = a[0][orderBy] ?? '';
      const itemB = b[0][orderBy] ?? '';

      if (itemA < itemB) return order === 'asc' ? -1 : 1;
      if (itemA > itemB) return order === 'asc' ? 1 : -1;
      return (a[0].listOrder ?? a[1]) - (b[0].listOrder ?? b[1]);
    });

    return stabilized.map((el) => el[0]);
  };

  const sortedData = getSortedData(data);
  const paginatedData = sortedData.slice(page * rowsPerPage, (page + 1) * rowsPerPage);

  const handleDownload = (url) => {
    if (!url) return;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div>
      <p className="mb-2 text-muted">
        {data.length} certificado(s) encontrado(s). Página {page + 1} de {totalPages}
      </p>

      <Card
        className={getModernDataTableClass(currentTheme)}
      >
        <Card.Header
          className={getModernCardHeaderClass(currentTheme)}
        >
          Certificados de calibração
        </Card.Header>
        <Card.Body
          className={getModernCardBodyClass(currentTheme)}
        >
          {data.length === 0 ? (
            <p className="text-center text-muted mb-0 py-4">
              Nenhum certificado disponível.
            </p>
          ) : (
            <Table
              style={{ fontSize: '0.9rem' }}
              hover
              responsive
              size="sm"
              className={getModernTableClass(currentTheme)}
            >
              <thead>
                <tr className={getTableHeaderClass(currentTheme)}>
                  <th
                    className="text-center"
                    onClick={() => handleRequestSort('serialnumber')}
                    style={{ cursor: 'pointer' }}
                  >
                    Nº SÉRIE {renderSortIcon('serialnumber')}
                  </th>
                  <th
                    className="text-center"
                    onClick={() => handleRequestSort('cupid')}
                    style={{ cursor: 'pointer' }}
                  >
                    CUP ID {renderSortIcon('cupid')}
                  </th>
                  <th
                    className="text-center"
                    onClick={() => handleRequestSort('fileName')}
                    style={{ cursor: 'pointer' }}
                  >
                    ARQUIVO {renderSortIcon('fileName')}
                  </th>
                  <th className="text-center">DOWNLOAD</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData.map((item) => (
                  <tr key={item._id}>
                    <td className="pt-2">{item.serialnumber}</td>
                    <td className="text-center pt-2 pb-2">{item.cupid}</td>
                    <td className="text-center pt-2 pb-2 text-break">{item.fileName || '--'}</td>
                    <td className="text-center pt-2 pb-2">
                      <Button
                        size="sm"
                        variant="success"
                        disabled={!item.downloadUrl}
                        onClick={() => handleDownload(item.downloadUrl)}
                        title="Baixar certificado"
                      >
                        <FaDownload className="me-1" />
                        Download
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Card.Body>

        {data.length > 0 && (
          <Card.Footer
            className={getModernCardFooterClass(currentTheme)}
          >
            <div>
              <label>
                Linhas por página:{' '}
                <select className="modern-data-table__rows-select" value={rowsPerPage} onChange={handleChangeRowsPerPage}>
                  {[20, 40, 60].map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </label>
            </div>
            <Pagination className="custom-pagination mb-0" variant="dark">
              <Pagination.Prev
                onClick={() => handleChangePage(page - 1)}
                disabled={page === 0}
                aria-label="Página anterior"
              />
              {getPaginationRange().map((index) => (
                <Pagination.Item
                  key={index}
                  active={index === page}
                  onClick={() => handleChangePage(index)}
                >
                  {index + 1}
                </Pagination.Item>
              ))}
              <Pagination.Next
                onClick={() => handleChangePage(page + 1)}
                disabled={page >= totalPages - 1}
                aria-label="Próxima página"
              />
            </Pagination>
          </Card.Footer>
        )}
      </Card>
    </div>
  );
};

export default Results;
